import { Moment } from "moment";

export enum AppConfigsActionTypes {
  FETCH_BRANCH_LIST = 'FETCH_BRANCH_LIST',
  FETCH_BUSINESS_DATE = 'FETCH_BUSINESS_DATE',
}

export interface BranchListType {
    value: string;
    label: string;
}

export interface AppConfigsState {
  branchList: BranchListType[]
  businessDate: Moment;
  gniTime: []
}

export interface FetchAppConfigsSuccessAction {
    type: AppConfigsActionTypes.FETCH_BRANCH_LIST
    payload: BranchListType[]
}

export interface FetchBusinessDateSuccessAction {
    type: AppConfigsActionTypes.FETCH_BUSINESS_DATE
    payload: Moment
}

export type AppConfigsActions = FetchAppConfigsSuccessAction | FetchBusinessDateSuccessAction